import { gql } from '@apollo/client';

export const ALL_TARGET_AUDIENCES = gql`
  query AllTargetAudiences($targetGroupId: ID) {
    targetAudiences: getTargetAudiences(targetGroupId: $targetGroupId) {
      id
      name
    }
  }
`;
